import { createAction, props } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';

export const CONVERT_TO_WILL_CALL_TRACING_ACTIONS = {
  traceConvertToWillCall: createAction(
    '[NGRXTrace - Order] Convert To Will Call Button Click',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceEditConvertToWillCall: createAction(
    '[NGRXTrace - Order] Edit Convert To Will Call Button Click',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceSubmitWillCallFormModalDismiss: createAction(
    '[NGRXTrace - Order] Submit Will Call Order Start',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceSubmitWillCallFormApiRequest: createAction(
    '[NGRXTrace - Order] Submit Will Call Api Request',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceEditWillCallSubmissionApiRequest: createAction(
    '[NGRXTrace - Order] Edit Will Call Order Submission Start',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceSubmitWillCallFormApiSuccess: createAction(
    '[NGRXTrace - Order] Track Submit Will Call Api Response Success',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceSubmitWillCallFormApiFailed: createAction(
    '[NGRXTrace - Order] Track Submit Will Call Api Response Fail',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceSubmitWillCallWebSocketResponseSuccess: createAction(
    '[NGRXTrace - Order] Track Submit Will Call Order WebSocket Response Success',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceSubmitWillCallWebSocketResponseFail: createAction(
    '[NGRXTrace - Order] Track Submit Will Call Order WebSocket Response Fail',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceWillCallConfirmationModalCancelClick: createAction(
    '[NGRXTrace - Order] Submit Will Call Confirmation Modal Cancel',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceWillCallFormModalCancelClick: createAction(
    '[NGRXTrace - Order] Submit Will Call Form Modal Cancel',
    props<{
      tracking: Tracking;
    }>(),
  ),
};
